export default "__VITE_ASSET__CoFDdCjd__"